import Nullstack from 'nullstack';
export default function IconError404({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-error-404",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 7v4a1 1 0 0 0 1 1h3"
  }), "   ", Nullstack.element("path", {
    d: "M7 7v10"
  }), "   ", Nullstack.element("path", {
    d: "M10 8v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1z"
  }), "   ", Nullstack.element("path", {
    d: "M17 7v4a1 1 0 0 0 1 1h3"
  }), "   ", Nullstack.element("path", {
    d: "M21 7v10"
  }), " ");
}